import React from 'react';
import { useSelector } from 'react-redux';

const CheckoutRightSection = () => {
    const cartItems = useSelector(state => state.cart);

    const totalAmount = Array.isArray(cartItems?.items)
        ? cartItems.items.reduce(
            (total, item) => total + (parseInt(item.product_price) * item.quantity),
            0
        )
        : 0;


    return (
        <div className='w-full h-full flex flex-col p-4 border-4 rounded-md'>
            <div className='text-2xl text-center p-4'>
                Thông tin đơn hàng
            </div>
            {cartItems?.items && cartItems?.items.length > 0 ? (
                cartItems.items.map((item) => {
                    if (item.quantity > 0) {
                        return (
                            <div key={item.productId} className='w-full h-full flex justify-between bg-white rounded-md p-2 border-b-2 text-base'>
                                <div className='w-28 h-auto'>
                                    <img src={item.imageURL} alt="" className='w-20 h-20 drop-shadow-lg' />
                                </div>
                                <div className='flex flex-col justify-center items-center'>
                                    <div className='text-md'>
                                        {item.product_name}
                                    </div>
                                    <div className='text-sm'>
                                        {item.quantity} x {parseFloat((parseFloat(item?.product_price))).toLocaleString('en-US')} <span className='text-red-500'>đ</span>
                                    </div>
                                </div>
                                <div className='flex justify-center items-center'>
                                    {parseFloat((parseFloat(item?.product_price) * item.quantity)).toLocaleString('en-US')} <span className='text-red-500'>đ</span>
                                </div>
                            </div>
                        );
                    } else {
                        return null; // Don't render if quantity is 0
                    }
                })
            ) : (
                <div>No items in the cart.</div>
            )}
            <div className='flex justify-end'>
                <div className='bg-red-700 text-white p-4 mt-4 border-2 rounded-md border-orange-400'>Tổng cộng : {parseFloat(totalAmount).toLocaleString('en-US')} đ</div>
            </div>

        </div>
    );
}

export default CheckoutRightSection;
